import { createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';

export const selectSubscriptionState = createSelector(selectDashboardState, (dashboard) => dashboard?.subscription);

export const selectIsLoadingSubscription = createSelector(
  selectSubscriptionState,
  (subscriptionState) => subscriptionState?.loadingSubscription
);

export const selectSubscriptionLoaded = createSelector(
  selectSubscriptionState,
  (subscriptionState) => subscriptionState?.subscriptionLoaded
);

export const selectSelectedSubscription = createSelector(
  selectSubscriptionState,
  (subscriptionState) => subscriptionState?.fetchedSubscription
);
